/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { BaseDrawerCore } from '../base';
import { MODAL_DRAWER_CONSTANTS } from './modal-drawer-constants';
export class ModalDrawerCore extends BaseDrawerCore {
    constructor(_adapter) {
        super(_adapter);
        this._adapter = _adapter;
        this._open = false;
        this._backdropClickListener = this._onBackdropClick.bind(this);
    }
    initialize() {
        super.initialize();
        this._adapter.setBackdropCloseListener(this._backdropClickListener);
        this._setBackdrop(this._open, { immediate: true });
    }
    async _triggerDrawerOpen() {
        super._triggerDrawerOpen();
        this._setBackdrop(true);
    }
    async _triggerDrawerClose() {
        super._triggerDrawerClose();
        this._setBackdrop(false);
    }
    _onBackdropClick(_evt) {
        const canClose = this._adapter.emitHostEvent(MODAL_DRAWER_CONSTANTS.events.CLOSE, undefined, true, true);
        if (canClose) {
            this.open = false;
        }
    }
    async _setBackdrop(open, { immediate = false } = {}) {
        if (open) {
            this._adapter.toggleBackdropClass(false, MODAL_DRAWER_CONSTANTS.classes.SCRIM_CLOSED);
            this._adapter.setBackdropVisibility(true, { immediate });
        }
        else if (this._adapter.isConnected) {
            await this._adapter.setBackdropVisibility(false, { immediate });
            if (!this._open) {
                this._adapter.toggleBackdropClass(true, MODAL_DRAWER_CONSTANTS.classes.SCRIM_CLOSED);
            }
        }
    }
}
